// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { RbFragmentDoc, RingBuilderFragmentFragmentDoc, RingBuilderMountFragmentFragmentDoc, RingBuilderMountEngagementRingFragmentDoc, RingBuilderCentreStoneFragmentFragmentDoc } from '../../graphql/api/ring-builder/rb.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../router/fragments/engagementRingLink.fragment.generated';
import { CatalogueEngagementRingInputFragmentDoc } from '../../graphql/api/ring-builder/catalogueEngagementRingInput.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../components/monolithImageSize.fragment.generated';
import { RecommendedRingSizeFragmentDoc } from '../../graphql/api/product/rings/fragments/recommendedRingSize.fragment.generated';
import { RingSizeFragmentDoc } from '../../graphql/api/product/rings/fragments/ringSize.fragment.generated';
import { ProductPageMetaFragmentDoc } from '../../views/product/composables/useProductPageMeta.generated';
import { AssetFragmentDoc } from '../../graphql/api/fragments/asset.fragment.generated';
import { MetalFilterMetalFragmentDoc } from '../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { MoneyFragmentDoc } from '../../graphql/api/fragments/money.fragment.generated';
import { SignatureStoneInputFragmentDoc } from '../../graphql/api/product/rings/engagement/ring/fragments/signatureStoneInput.fragment.generated';
import { StoneFragmentDoc } from '../../graphql/api/stone/gems/fragments/stone.fragment.generated';
import { StoneCategoryFragmentDoc } from '../../graphql/api/stone/gems/fragments/StoneCategory.fragment.generated';
import { StoneCategoryTranslationFragmentDoc } from '../../graphql/api/stone/gems/fragments/StoneCategoryTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from '../../graphql/api/stone/gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../../graphql/api/stone/gems/fragments/ClarityTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../../graphql/api/stone/gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../../graphql/api/stone/gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneCrystalTranslation.fragment.generated';
import { StoneImageFragmentDoc } from '../../graphql/api/stone/gems/fragments/image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../domain/stone/certificate.generated';
import { GemsApiStoneAnalyticsFragmentDoc, NonSkuGemstoneAnalyticsFragmentDoc, NonSkuLabGrownAnalyticsFragmentDoc } from '../../views/product/composables/analytics/useProductAnalytics.generated';
import { NonSkuGemstoneFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/nonSkuGemstone.fragment.generated';
import { StoneShapeFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneShape.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneShapeTranslation.fragment.generated';
import { StoneCutFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneCut.fragment.generated';
import { StoneCutTranslationFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneCutTranslation.fragment.generated';
import { StoneGradeFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/stoneGrade.fragment.generated';
import { NonSkuGemstoneImageFragmentDoc } from '../../domain/stone/nonSkuGemstoneImage.fragment.generated';
import { NonSkuLabGrownFragmentDoc } from '../../graphql/api/stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { NonSkuLabGrownStoneImageFragmentDoc } from '../../domain/stone/nonSkuLabGrownStoneImage.fragment.generated';
import { TaxSnippetFragmentDoc } from '../../components/rings/TaxSnippet.generated';
import { AffirmFinanceOptionsFragmentDoc } from '../../graphql/api/checkout/payment/affirmFinanceOptions.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const RingBuilderDocument = `
    query ringBuilder($locale: Locale!, $currency: CurrencyInput!, $country: CountryCode!) {
  ringBuilder(input: {country: $country, currency: $currency}) {
    ...rb
  }
}
    ${RbFragmentDoc}
${RingBuilderFragmentFragmentDoc}
${RingBuilderMountFragmentFragmentDoc}
${RingBuilderMountEngagementRingFragmentDoc}
${EngagementRingLinkFragmentDoc}
${CatalogueEngagementRingInputFragmentDoc}
${MonolithImageSizeFragmentDoc}
${RecommendedRingSizeFragmentDoc}
${RingSizeFragmentDoc}
${ProductPageMetaFragmentDoc}
${AssetFragmentDoc}
${MetalFilterMetalFragmentDoc}
${MoneyFragmentDoc}
${SignatureStoneInputFragmentDoc}
${RingBuilderCentreStoneFragmentFragmentDoc}
${StoneFragmentDoc}
${StoneCategoryFragmentDoc}
${StoneCategoryTranslationFragmentDoc}
${StoneClarityFragmentDoc}
${ClarityTranslationFragmentDoc}
${StoneColorFragmentDoc}
${StoneColorTranslationFragmentDoc}
${StoneCrystalFragmentDoc}
${StoneCrystalTranslationFragmentDoc}
${StoneImageFragmentDoc}
${GemsApiCertificateFragmentDoc}
${GemsApiStoneAnalyticsFragmentDoc}
${NonSkuGemstoneFragmentDoc}
${StoneShapeFragmentDoc}
${StoneShapeTranslationFragmentDoc}
${StoneCutFragmentDoc}
${StoneCutTranslationFragmentDoc}
${StoneGradeFragmentDoc}
${NonSkuGemstoneImageFragmentDoc}
${NonSkuLabGrownFragmentDoc}
${NonSkuLabGrownStoneImageFragmentDoc}
${NonSkuGemstoneAnalyticsFragmentDoc}
${NonSkuLabGrownAnalyticsFragmentDoc}
${TaxSnippetFragmentDoc}
${AffirmFinanceOptionsFragmentDoc}`;

export function useRingBuilderQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.RingBuilderQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.RingBuilderQuery, SchemaTypes.RingBuilderQueryVariables | undefined>({ query: RingBuilderDocument, variables: undefined, ...options });
};